"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
require("../../common/style.scss");
var _gemUrlFormatUtils = require("../../common/utils/domain/gemUrlFormatUtils");
var _formatBanner = require("../../utils/formatBanner");
var _tpmProductIntl = require("@tencent/tpm-product-intl");
var _intlDesignUi = require("@tencent/intl-design-ui");
var _reportUtil = require("../../utils/reportUtil");
var _componentUtils = require("../../common/componentUtils");
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 */
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} “数据”表单内容
  style,
  // {object} “样式”表单内容
  commonStyle,
  // {object} “组件自定义样式”表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos
}) {
  const domains = (0, _gemUrlFormatUtils.useDomainGems)({
    domainInfos
  });
  if (Object.keys(data).length > 1) {
    const _formatBannerCommon = (0, _formatBanner.formatBannerCommon)(data, {
        domains
      }),
      _formatBannerCommon$i = _formatBannerCommon.isMap,
      isMap = _formatBannerCommon$i === void 0 ? false : _formatBannerCommon$i,
      title = _formatBannerCommon.title,
      content = _formatBannerCommon.content,
      backgroundUrl = _formatBannerCommon.backgroundUrl,
      mobileBackgroundUrl = _formatBannerCommon.mobileBackgroundUrl,
      backgroundUrlLogo = _formatBannerCommon.backgroundUrlLogo,
      backgroundVideoUrl = _formatBannerCommon.backgroundVideoUrl,
      lightTheme = _formatBannerCommon.lightTheme,
      buttonList = _formatBannerCommon.buttonList,
      tabList = _formatBannerCommon.tabList,
      liveType = _formatBannerCommon.liveType,
      tabTitle = _formatBannerCommon.tabTitle,
      tagText = _formatBannerCommon.tagText,
      tagHref = _formatBannerCommon.tagHref,
      activityBtnText = _formatBannerCommon.activityBtnText;
    if (isMap) {
      // 分离带有 filedVideoList 的按钮和其他按钮
      const videoBtn = buttonList.filter(btn => btn.filedVideoList);
      const otherBtns = buttonList.filter(btn => !btn.filedVideoList);

      // 转化Banner主按钮（来自otherBtns的第一个）
      const handleBtn = () => {
        if (otherBtns.length === 0) return null;
        const btnExtendProps = {
          'report-event': 'click_heroBanner_button_primary',
          'report-ext1': otherBtns[0].label || '',
          'report-ext2': otherBtns[0].href || '',
          target: '_blank'
        };
        return /*#__PURE__*/React.createElement(_tpmProductIntl.Button, Object.assign({
          type: 'primary',
          icon: true,
          href: otherBtns[0].href
        }, btnExtendProps), otherBtns[0].label);
      };

      // 转化Banner次按钮（otherBtns中除了第一个以外的按钮）
      const handleWeakBtn = otherBtns.slice(1).map((item, index) => {
        const label = item.label,
          href = item.href;
        const btnExtendProps = {
          'report-event': `click_heroBanner_button_weak`,
          'report-ext1': index,
          'report-ext2': label || '',
          'report-ext3': href || '',
          target: '_blank'
        };
        return {
          text: label,
          btns: [_objectSpread({
            text: label,
            href
          }, btnExtendProps)]
        };
      });
      let activityList = [];

      // 如果存在视频按钮，可以在此处理视频按钮的逻辑
      if (videoBtn) {
        videoBtn.map(item => {
          activityList.push({
            type: 'video',
            text: item.label,
            video: (0, _componentUtils.doComponentsUploadEvent)(item.filedVideoList).url,
            img: 'https://staticintl.cloudcachetci.com/tencent_act_ui_static/event/2025/CMS/img/hero-video-bg-default.png'
          });
        });
      }

      // 转化运营位
      if (tagText && tagHref) {
        const btnExtendProps = {
          'report-event': 'click_heroBanner_activity_item',
          'report-ext2': activityBtnText || '',
          'report-ext3': tagHref || '',
          target: '_blank'
        };
        activityList.push({
          type: 'card',
          title: tagText,
          btns: /*#__PURE__*/React.createElement(_tpmProductIntl.Button, Object.assign({
            type: 'weak',
            href: tagHref
          }, btnExtendProps), activityBtnText || 'View More')
        });
      }
      return /*#__PURE__*/React.createElement("div", Object.assign({
        className: `gems-materials-qci____newUI-TpmCommonBanner`
      }, (0, _reportUtil.reportShow)(['show_newUI_TpmCommonBanner', componentKey, title || ''])), /*#__PURE__*/React.createElement(_tpmProductIntl.Hero, {
        isOldVersion: true,
        title: title,
        desc: content,
        img: (0, _componentUtils.doComponentsUploadEvent)(backgroundUrl || '').url,
        mobileImg: (0, _componentUtils.doComponentsUploadEvent)(mobileBackgroundUrl || '').url,
        video: (0, _componentUtils.doComponentsUploadEvent)(backgroundVideoUrl || '').url,
        btns: otherBtns.length ? handleBtn() : null,
        weakBtn: otherBtns.length > 1 ? handleWeakBtn : null,
        activityList: activityList,
        productFamily: tabList.length > 0 ? tabList.map(item => ({
          name: item.text,
          href: item.href,
          selected: item.chosed
        })) : [],
        type: 'common'
      }));
    }
    return /*#__PURE__*/React.createElement("div", Object.assign({
      className: "gems-materials-qci__new-banner"
    }, (0, _reportUtil.reportShow)(['show_newBanner', componentKey, title])), /*#__PURE__*/React.createElement(_intlDesignUi.Banner, {
      title: title,
      content: content,
      backgroundUrl: backgroundUrl,
      backgroundUrlLogo: backgroundUrlLogo,
      backgroundVideoUrl: backgroundVideoUrl,
      lightTheme: lightTheme,
      buttonList: buttonList,
      tagText: tagText,
      tagHref: tagHref,
      tabTitle: tabTitle,
      tabList: tabList,
      liveType: liveType,
      onCallback: item => {
        // 解决方案只有合作伙伴页才需要这个逻辑
        if (window.location.href.indexOf('partner') === -1 || item.href.indexOf('partners') === -1) {
          window.asyncReceiveCommodity(item);
          return;
        }
        window.checkAccountType();
      }
    }));
  } else {
    return /*#__PURE__*/React.createElement("div", null);
  }
}